import Box from '@/components/UI/box/Box';
import Drawer from '@/components/UI/drawer/Drawer';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import styles from './ReservationDetailsDrawer.module.scss';
import Button from '@/components/UI/button/Button';
import IncrementStepper from '@/components/reusable/incrementStepper/IncrementStepper';
import PaymentSteps from '../paymentSteps/PaymentSteps';
import MidTermFactor from '@/components/houses/housesDesktop/midTermFactor/MidTermFactor';
import { useSelector } from 'react-redux';
import Divider from '@/components/UI/divider/Divider';
import { formatPersianDates } from '@/helpers/dateManager';
const ReservationDetailsDrawer = ({
  open,
  onClose,
  checkin,
  checkout,
  guests,
  maxAccommodates,
  handleDateChange,
  handleStepperChange,
  onSendReserveRequestClick,
  baseAccommodates,
  loading
}) => {
  const proformaState = useSelector(state => state.proforma);
  const convertDateTime = time => {
    const convertedTime = new Date(time * 1000);
    const comvertedDates = formatPersianDates(convertedTime, {
      month: 'long',
      day: 'numeric'
    }).year.split(' ');
    return `${comvertedDates[0]} ${comvertedDates[1]} `;
  };
  return <Drawer fullHeight open={open} onClose={onClose} data-sentry-element="Drawer" data-sentry-component="ReservationDetailsDrawer" data-sentry-source-file="ReservationDetailsDrawer.tsx">
      <Box className={styles['factor-header']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
        <Icon onClick={onClose} type="highEmphasis" name="close" data-sentry-element="Icon" data-sentry-source-file="ReservationDetailsDrawer.tsx" />
        <Typography variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="ReservationDetailsDrawer.tsx">جزییات رزرو</Typography>
      </Box>
      <Box className={styles['reservation-details-body']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
        <Box className={styles['factor-content']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
          <Box className={styles['factor-details']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
            <Box className={styles['factor-dates']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
              <Typography component="p" variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="ReservationDetailsDrawer.tsx">
                تاریخ سفر
              </Typography>
              <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="ReservationDetailsDrawer.tsx">
                {!!checkin && convertDateTime(checkin)}
              </Typography>
              <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="ReservationDetailsDrawer.tsx"> تا </Typography>
              <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="ReservationDetailsDrawer.tsx">
                {!!checkout && convertDateTime(checkout)}
              </Typography>
            </Box>
            <Box className={styles['change-date-button']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
              <Button onClick={handleDateChange} format="outlined" endIcon="arrow-left-1" data-sentry-element="Button" data-sentry-source-file="ReservationDetailsDrawer.tsx">
                تغییر تاریخ
              </Button>
            </Box>
          </Box>

          <Box className={styles['guest-wrapper']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
            <Box className={styles['factor-guests-text']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
              <Typography component="p" variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="ReservationDetailsDrawer.tsx">
                تعداد نفرات
              </Typography>
              <Typography component="p" variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="ReservationDetailsDrawer.tsx">
                {` ${Number(guests) <= baseAccommodates ? guests : baseAccommodates} نفر پایه ${Number(guests) > baseAccommodates ? `+ ${Number(guests) - baseAccommodates} نفر اضافه` : ''}`}{' '}
              </Typography>
            </Box>
            <IncrementStepper format="base" handleChange={handleStepperChange} label={``} maximumValue={maxAccommodates} minimumValue={1} value={Number(guests) || 1} data-sentry-element="IncrementStepper" data-sentry-source-file="ReservationDetailsDrawer.tsx" />
          </Box>
          <Divider data-sentry-element="Divider" data-sentry-source-file="ReservationDetailsDrawer.tsx" />
          <Box className={styles['mid-term-invoice-details']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
            <MidTermFactor proformaState={proformaState} data-sentry-element="MidTermFactor" data-sentry-source-file="ReservationDetailsDrawer.tsx" />
            <PaymentSteps data-sentry-element="PaymentSteps" data-sentry-source-file="ReservationDetailsDrawer.tsx" />
          </Box>
        </Box>
        <Box className={styles['factor-footer']} data-sentry-element="Box" data-sentry-source-file="ReservationDetailsDrawer.tsx">
          <Button disabled={loading} loading={loading} onClick={onSendReserveRequestClick} format="primary" data-sentry-element="Button" data-sentry-source-file="ReservationDetailsDrawer.tsx">
            ثبت رزرو
          </Button>
        </Box>
      </Box>
    </Drawer>;
};
export default ReservationDetailsDrawer;